// removed by extract-text-webpack-plugin
module.exports = {"ListItem":"_3P4Wx","ListItemActive":"_2UI6B","Box":"_2jX1L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/AutoSuggestBox/AutoSuggestList/AutoSuggestListItem/AutoSuggestListItem.scss
// module id = 881
// module chunks = 0